import * as React from 'react';
import { meters2ScreenPixels } from "google-map-react/utils";
import LensICon from './LensICon';
import markerImage from "../../../../../images/marker.svg"

import { Radius } from '../../common/Radius';
import { GeoSearchCard } from 'src/modules/GeoSearch/View/components/GeoSearchCard';
import { IMapClusters, MapClustersTypes } from '../MapClusters';
import AlertCard from 'src/modules/Alert/View/components/AlertCard';
import { getZoom } from 'src/share/utils/utils';
import './marker.css';


export interface IMarkerProps {
  centerBoundsPoints: () => void;
  history: any;
  inGroup?: boolean;
  lat: number;
  lng: number;
  points: IMapClusters[];
  mapType: MapClustersTypes;
  radius: number;
  id: string;
  zoom: number;
}

export interface IMarkerState {
  hoverElement: {
    isOnRadius: boolean;
    isOnTooltip: boolean;
  };
}
const MILESTOMETERS = 1609.34;
class Marker extends React.PureComponent<IMarkerProps, IMarkerState> {
  constructor(props: IMarkerProps) {
    super(props);
    this.state = {
      hoverElement: {
        isOnRadius: false,
        isOnTooltip: false
      }
    }
  }
  private getRadiusSize(lat: number, lng: number, zoom: number) {
    const { radius } = this.props;
    if (lat && lng && radius) {
      return meters2ScreenPixels(radius * MILESTOMETERS, { lat, lng }, zoom);
    }
    return { w: 0, h: 0 };
  }
  public onMouseOver = (elementName: 'isOnRadius' | 'isOnTooltip') => () => {
    if (!this.state.hoverElement[elementName]) {
      this.setState(state => ({ hoverElement: { ...state.hoverElement, [elementName]: true } }))
    }
  }
  public onMouseOut = (elementName: 'isOnRadius' | 'isOnTooltip') => () => {
    if (this.state.hoverElement[elementName]) {
      this.setState(state => ({ hoverElement: { ...state.hoverElement, [elementName]: false } }))
    }
  }
  public render() {
    const { id, lat, lng, points, radius, zoom, inGroup, history, mapType } = this.props;
    const { w, h } = this.getRadiusSize(lat, lng, zoom);
    const { isOnRadius, isOnTooltip } = this.state.hoverElement;
    const showTooltip = isOnRadius || isOnTooltip;
    const isAlertClusterMap = mapType === MapClustersTypes.ALERTS;
    const mapIsClose = zoom < (isAlertClusterMap ? (getZoom(radius) + 2) : 12);
    return (
      <div key={id}>
        {inGroup && mapIsClose || mapIsClose ?
          <div onClick={() => this.props.centerBoundsPoints()} onMouseOver={!inGroup ? this.onMouseOver('isOnRadius') : undefined}
            onMouseOut={this.onMouseOut('isOnRadius')} className={isAlertClusterMap && inGroup ? 'MarkerInGroupStyledAlert' : inGroup ? 'MarkerInGroupStyled' : 'MarkerStyled'}>
            {isAlertClusterMap ?
              <div className="marker-container">
                <img className="marker" src={markerImage} />
              </div> : <LensICon scale="1" />}
          </div>
          : <Radius onMouseOver={this.onMouseOver('isOnRadius')} onMouseOut={this.onMouseOut('isOnRadius')} height={h} width={w} mapClusterType={this.props.mapType} />
        }
        {showTooltip && points.length > 0 &&
          <div className="custom-tooltip-radius" onMouseEnter={this.onMouseOver('isOnTooltip')} onMouseLeave={this.onMouseOut('isOnTooltip')}>
            {points.map(point =>
              isAlertClusterMap ?
                <AlertCard
                  key={point.id}
                  alert={{
                    alertId: point.id,
                    alert: '',
                    caseId: point.caseId,
                    location: point.location as string,
                    center: { lat: point.lat, lng: point.lng },
                    radius: point.radius,
                    expirationDate: point.expirationDate,
                    language: '',
                    phone: '',
                    createdAt: point.date,
                    expired: point.expired,
                    lastUpdate: 0,
                    agencyCode: '',
                    stop: point.stop as "Yes" | "No"
                  }}
                  history={history} /> :
                <GeoSearchCard
                  key={point.id}
                  id={point.id}
                  caseId={point.caseId}
                  date={point.date}
                  radius={point.radius}
                  editable={false}
                  title={point.manual ? point.searchName || "Manual Search" : point.person ? point.person.fullName : ""}
                  history={history}
                />
            )}
          </div>
        }
      </div>
    );
  }
}

export default Marker;



// WEBPACK FOOTER //
// ./src/share/components/Maps/MapClusters/components/Marker.tsx